/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import withValidarRecuperar from "HOC/withValidarRecuperar";
import { ApiKeyFetch } from "api/fetchers/apiKey";
import imgBreadCrum from "assets/img/mex/accidentesPersonales/imgbreadcrumAP.png";
import ResumenAuto from "components/AutoMex/ResumenAuto";
import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import BreadCurmbPasos from "components/BreadCrumbMex/BreadCrumbTipo2";
import Page from "components/Page";
import { ambienteAplicacion } from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import useAlbert from "hooks/useAlbert";
import useConsultarParametrosPago from "hooks/useConsultarParametrosPago";
import useLoading from "hooks/useLoading";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { PASOS_BREADCRUMBS, PRODUCTOS } from "utils/constants";
import { getColorByIndex } from "utils/funciones";
import Loading from "wrappers/Loading";
import "./styles.scss";
import { urlCrearPoliza, urlRecuperarCotizacionPaginaTres, urlTarifar } from "./urls";
import { getSeleccionado } from "./utils";

const ResumenPlanPantalla3Container = ({
  params: { idCotizacion },
  history,
  addWarningToast,
  dataUsuario,
}) => {
  const { setProductoActivo } = useNavbarContext();
  const [loading, setLoading] = useState(false);
  const { cliCodigoCore } = dataUsuario;
  const [datosTarifacion, setDatosTarifacion] = useState(null);

  const { loading: recalculando, setLoading: recalcular } = useLoading();
  const [permiteEmitir, setPermiteEmitir] = useState(true);
  const [cotizacion, setCotizacion] = useState(null);
  const [plan, setPlan] = useState(null);
  const [asistencias, setAsistencias] = useState([]);
  const [coberturasAdicionales, setCobAdicionales] = useState([]);
  const [labelMarcaAuto, setLabelMarcaAuto] = useState([]);
  const [showDescuentoVariable, setshowDescuentoVariable] = useState(false);
  const { fetchParametros } = useConsultarParametrosPago(PRODUCTOS.AUTO, idCotizacion);

  const { addAutoEvent, AUTO_EVENTS, AUTO_OPERATIONS } = useAlbert();
  const methods = useForm({ mode: "onChange" });

  const getResumen = async () => {
    setProductoActivo(PRODUCTOS.APINDIVIDUAL);
    setLoading(true);
    fetchParametros(); //cargar formas de pago Auto
    const DataResumen = {
      cotDatos: {
        ambiente: ambienteAplicacion,
        cotCodigo: idCotizacion,
        datosUsuario: {
          codigoUsuario: cliCodigoCore || "",
        },
      },
    };

    const resResumen = await ApiKeyFetch.instance().post(
      urlRecuperarCotizacionPaginaTres,
      DataResumen
    );

    if (resResumen.transaccion) {
      //Agregar Validacion de poliza finalizada
      if (resResumen?.cotConsulta?.polizaFinalizada) {
        addWarningToast(
          "No se puede modificar esta cotización puesto que ya se ha finalizado el proceso de emisión."
        );
        history.push("/auto");
      }
      const totales = resResumen.cotConsulta.totGenerales[0];
      setDatosTarifacion(totales);
      setCotizacion(resResumen.cotConsulta);

      const planSeleccionado = getSeleccionado(resResumen.cotConsulta.prodDatos);

      const index = resResumen.cotConsulta.prodDatos.indexOf(planSeleccionado);
      planSeleccionado.bgColor = getColorByIndex(index);
      setPlan(planSeleccionado);
      setAsistencias(planSeleccionado.codAsistenciasAdicional);
      setCobAdicionales(planSeleccionado.codCoberturasAdicional);
      setLabelMarcaAuto(resResumen.cotConsulta.carContratante.datosPlan.modeloAuto);
      methods.setValue("descuentoVariaSelecciono", { label: "0%", value: 0 });
    }
    setLoading(false);
  };

  useEffect(() => {
    getResumen();
  }, []);

  useEffect(() => {
    if (datosTarifacion) {
      if (!datosTarifacion?.permitirEmitir) {
        addWarningToast(datosTarifacion.msgError);
      }
      setPermiteEmitir(datosTarifacion?.permitirEmitir);
    }
  }, [datosTarifacion]);

  const tarifar = async ({ idPlazo, formaPago, labelPlazo }) => {
    recalcular(true);

    const descuentoVariaSelecciono = parseInt(methods.getValues("descuentoVariaSelecciono"));

    const DataTarifacion = {
      ambiente: ambienteAplicacion,
      cotCodigo: idCotizacion,
      idPlazo,
      formaPago,
      labelPlazo,
      descuentoVariaSelecciono,
      actualizarCoberturas: true,
      datosCotizador: {
        codigoUsuario: cliCodigoCore || "",
      },
    };
    const res = await ApiKeyFetch.instance().post(urlTarifar, DataTarifacion);

    if (res.transaccion) {
      setDatosTarifacion(res.datosTarifacion);

      setCotizacion({
        ...cotizacion,
        carUrlPdf: res.datosTarifacion.urlPdfCotizacion,
      });
      delete res.datosTarifacion.urlPdfCotizacion;

      recalcular(false);
    } else {
      return addWarningToast("Ha ocurrido un problema al realizar la tarifación");
    }
    setshowDescuentoVariable(false);
  };

  const onContinuar = async () => {
    const Data = {
      datosCotizador: {
        ambiente: ambienteAplicacion,
        prodCodigo: PRODUCTOS.AUTO,
        cotPasoCodigo: "crearPoliza",
        cotCodigo: idCotizacion,
      },
    };
    addAutoEvent(AUTO_OPERATIONS.albert_dtc_auto, AUTO_EVENTS.albert_payment_info);
    setLoading(true);

    const res = await ApiKeyFetch.instance().post(urlCrearPoliza, Data);

    if (res.transaccion && res.catalogo.idPoliza) {
      const route = res?.catalogo?.pasosRedireccionamiento.find((e) => e.codigo === "resumen");

      history.replace(route.goTo);
      history.push(route.goTo);
    }

    setLoading(false);
  };

  const onClickAtras = () => {
    history.push(`/auto-planes/${idCotizacion}?recuperar=true`);
  };

  const onError = () => {
    addWarningToast("Por favor complete la información del pago");
  };
  const onChangeDescuentoRecargo = (value) => {
    setshowDescuentoVariable(value);
  };
  return (
    <React.Fragment>
      <Loading loading={loading}>
        {cotizacion && datosTarifacion && plan && (
          <FormProvider {...methods}>
            <div className='cr-content'>
              <Page>
                <BreadCurmb {...PASOS_BREADCRUMBS.AUTO.breadCrumb} />
                <BreadCurmbPasos {...PASOS_BREADCRUMBS.AUTO.breadCrumbPasos[3]} />

                <ResumenAuto
                  cotizacion={cotizacion}
                  plan={plan}
                  asistencias={asistencias}
                  coberturasAdicionales={coberturasAdicionales}
                  datosTarifacion={datosTarifacion}
                  idCotizacion={idCotizacion}
                  imgBreadCrum={imgBreadCrum}
                  dataUsuario={dataUsuario}
                  setDatosTarifacion={setDatosTarifacion}
                  recalculando={recalculando}
                  recalcular={recalcular}
                  tarifar={tarifar}
                  labelMarcaAuto={labelMarcaAuto}
                  changeDescuentoRecargo={onChangeDescuentoRecargo}
                  showDescuentoVariable={showDescuentoVariable}
                  addWarningToast={addWarningToast}
                />

                <div className='row justify-content-center my-5'>
                  <div className='col-11 col-sm-5 col-md-3 col-xl-2'>
                    <button className='btn btn-atras-api' onClick={onClickAtras}>
                      Atrás
                    </button>
                  </div>
                  <div className='col-11 col-sm-5  col-md-3 col-xl-2'>
                    <button
                      className='btn btn-siguiente-api'
                      onClick={methods.handleSubmit(onContinuar, onError)}
                      type='submit'
                      disabled={recalculando || !permiteEmitir}
                      //disabled={false}
                    >
                      Siguiente
                    </button>
                  </div>
                </div>
              </Page>
            </div>
          </FormProvider>
        )}
      </Loading>
    </React.Fragment>
  );
};

export default withValidarRecuperar(ResumenPlanPantalla3Container);
